import React from 'react';
import {Dialog, DialogTitle, DialogActions, Typography, Box} from '@mui/material';
import CustomButton from './Button';
import {SD_BUTTON_RADIUS} from '../../constants/ui-tokens';

const NewModal = ({open, onClose, title, subtitle, content, content_question, buttons, disclaimer, footer, modalbgColor = '#ffffff', modalTextColor = '#000000', modalTitleColor = '#000000', maxWidth = '350px', height, titleStyles, subtitleStyles, contentStyles, footerStyles}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          backgroundColor: modalbgColor,
          color: modalTextColor,
          padding: 1,
          overflow: 'hidden',
          width: '100vw',
          borderRadius: '14px',
          maxWidth: maxWidth,
          ...(height && {height: height})
        }
      }}
    >
      {/* Title */}
      {title && (
        <DialogTitle
          sx={{
            backgroundColor: modalbgColor,
            color: modalTitleColor,
            fontWeight: 700,
            fontSize: '24px',
            textAlign: 'center',
            ...titleStyles
          }}
        >
          {title}
        </DialogTitle>
      )}

      {/* Subtitle */}
      {subtitle && (
        <Typography
          sx={{
            textAlign: 'center',
            fontWeight: 600,
            color: '#d32f2f !important',
            mb: '20px',
            ...subtitleStyles
          }}
        >
          {subtitle}
        </Typography>
      )}

      {/* Content */}
      {content && (
        <Typography
          variant="body1"
          sx={{
            textAlign: 'center',
            fontWeight: 500,
            color: '#000 !important',
            fontSize: '16px',
            mb: '20px',
            p: '0 30px'
          }}
        >
          {content}
        </Typography>
      )}
      {content_question && (
        <Typography
          variant="body1"
          sx={{
            textAlign: 'center',
            fontWeight: 600,
            color: '#000 !important',
            fontSize: '16px',
            mb: '5px',
            p: '0 30px'
          }}
        >
          {content_question}
        </Typography>
      )}

      {/* Buttons */}
      <DialogActions sx={{justifyContent: 'center', padding: '10px 25px', gap: '10px'}}>
        {buttons?.map((button, index) => (
          <CustomButton key={index} type={button.type} onClick={button.onClick} text={button?.name} loading={button.loading} disabled={button.disabled} backgroundColor={button.buttonBgColor} textColor={button.buttonTextColor} hoverColor={button.buttonHoverColor} borderRadius={button?.borderRadius ?? SD_BUTTON_RADIUS} />
        ))}
      </DialogActions>

      {disclaimer && (
        <Typography
          sx={{
            textAlign: 'center',
            fontWeight: 500,
            color: '#666 !important',
            fontSize: '12px',
            mt: '-10px'
          }}
        >
          {disclaimer}
        </Typography>
      )}

      {/* Footer */}
      {footer && (
        <Box
          sx={{
            textAlign: 'center',
            fontSize: '12px',
            marginTop: '5px',
            color: '#666',
            p: '10px 20px',
            ...footerStyles
          }}
        >
          {footer}
        </Box>
      )}
    </Dialog>
  );
};

export default NewModal;

{
  /* <NewModal
  open={isOpen}
  onClose={() => setIsOpen(false)}
  title="Look’s Like the App is Working for You!"
  subtitle="That’s Exciting!"
  content="Cheers on starting a new group and making more disciples. We are excited that you are part of the SD Movement."
  content_question="Would you consider helping others get started too by supporting the app?"
  buttons={[
    { name: "I’LL HELP", onClick: handleHelp, buttonBgColor: "#000", buttonTextColor: "#fff", buttonHoverColor: '#f5f5f5' },
    { name: "NOT NOW", onClick: handleClose, buttonBgColor: "#fff", buttonTextColor: "#000", buttonHoverColor: '#f5f5f5' },
  ]}
  disclaimer= "PLEASE DON'T SHOW THIS MESSAGE AGAIN"
  footer="Your donation brings the same free startup that someone else’s donation brought you."
/> */
}

{
  /* <NewModal
  open={isOpen}
  onClose={() => setIsOpen(false)}
  title="Look’s Like the App is Working for You!"
  subtitle="That’s Exciting!"
  content="Cheers on starting a new group and making more disciples. We are excited that you are part of the SD Movement."
  content_question="Would you consider helping others get started too by supporting the app?"
  buttons={[
    { name: "YES", onClick: handleYes, buttonBgColor: "#000", buttonTextColor: "#fff", buttonHoverColor: '#f5f5f5' },
    { name: "NOT NOW", onClick: handleClose, buttonBgColor: "#fff", buttonTextColor: "#000", buttonHoverColor: '#f5f5f5' },
  ]}
  disclaimer= "PLEASE DON'T SHOW THIS MESSAGE AGAIN"
  footer="PLEASE DON’T SHOW THIS MESSAGE AGAIN"
/> */
}

{
  /* <NewModal
  open={isOpen}
  onClose={() => setIsOpen(false)}
  title="It Only Costs $16 to Make a Disciple."
  content="We are committed to sharing the resources God’s shared with us – even when folks can’t afford to share the cost."
  content_question="Would you consider helping others experience the same benefits you’re experiencing?"
  buttons={[
    { name: "YES", onClick: handleYes, buttonBgColor: "#000", buttonTextColor: "#fff", buttonHoverColor: '#f5f5f5' },
    { name: "NOT NOW", onClick: handleClose, buttonBgColor: "#fff", buttonTextColor: "#000", buttonHoverColor: '#f5f5f5' },
  ]}
  disclaimer= "PLEASE DON'T SHOW THIS MESSAGE AGAIN"
  footer="Your one time or monthly gift of $16 could change someone’s life forever."
/> */
}
